export default __webpack_public_path__ + "static/media/associer_appareil.82adb1f8.svg";